/* Cards Game Night — homepage interactions */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function cycler(items, speed, root) {
    if (!items.length || items.length < 2) return;
    var i = 0, timer;
    function next() {
      var cur = items[i];
      cur.classList.remove('is-active');
      cur.classList.add('is-out');
      setTimeout(function () { cur.style.transition = 'none'; cur.classList.remove('is-out'); void cur.offsetWidth; cur.style.transition = ''; }, 750);
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }
    function start() { if (!reduce) timer = setInterval(next, speed); }
    function stop() { clearInterval(timer); }
    start();
    if (root) {
      root.addEventListener('click', function () { stop(); next(); start(); });
      root.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); stop(); next(); start(); }
      });
    }
  }

  function initHero(scope) {
    scope.querySelectorAll('[data-cgn-hero]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '');
      cycler(el.querySelectorAll('.cgn-hero__a'), (parseFloat(el.dataset.speed) || 2.4) * 1000, el);
    });
  }

  function initNews(scope) {
    scope.querySelectorAll('[data-cgn-rot]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '');
      cycler(el.querySelectorAll('span'), 2200, null);
    });
  }

  function initSlider(scope) {
    scope.querySelectorAll('[data-cgn-slider]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '');
      var track = el.querySelector('.cgn-slider__track');
      el.querySelectorAll('[data-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var slide = track.querySelector('.cgn-slide');
          var step = slide ? slide.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
          track.scrollBy({ left: step * parseInt(btn.dataset.dir, 10), behavior: 'smooth' });
        });
      });
    });
  }

  function initFaq(scope) {
    scope.querySelectorAll('[data-cgn-faq]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '');
      var btn = el.querySelector('.cgn-faq__toggle');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var all = el.querySelectorAll('details');
        var open = btn.getAttribute('aria-expanded') !== 'true';
        all.forEach(function (d) { d.open = open; });
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? btn.dataset.close : btn.dataset.open;
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    initHero(scope); initNews(scope); initSlider(scope); initFaq(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
